import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

const BlogList: React.FC = () => {
  const { t, dir } = useLanguage();
  const isRtl = dir === "rtl";

  return (
    <section className="bg-white py-24 sm:py-28">
      <div className="site-container">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {t.blog.posts.map((post) => (
            <article
              key={post.title}
              className="overflow-hidden rounded-lg border border-stone-200 bg-stone-50 transition hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="h-48 bg-gradient-to-br from-second-color/12 to-main-color/30" />
              <div className="p-6">
                <div className={isRtl ? "text-right" : "text-left"}>
                  <span className="font-sans text-sm font-medium text-neutral-500">
                    {post.date}
                  </span>
                  <h3 className="mt-2 mb-3 font-sans text-xl font-semibold text-teal-900">
                    {post.title}
                  </h3>
                  <p className="mb-4 font-sans text-base font-normal leading-6 text-neutral-600">
                    {post.excerpt}
                  </p>
                </div>
                <div className={isRtl ? "text-right" : "text-left"}>
                  <button className="font-sans text-base font-semibold text-second-color transition-colors hover:text-teal-900">
                    {t.blog.readMore}
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogList;
